// extracted by mini-css-extract-plugin
export default {"image":"WIweM2"};